module.exports = __webpack_public_path__ + "static/media/stop-circle.54fb1188.svg";